module.exports = __webpack_public_path__ + "static/media/1.063302a2.jpg";